/*
 * Copyright Evollis 2024
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from "../../../core/utils"
import { getSessionVoyageurLang } from "../../../core/voyageurLanguage"
import CheckboxField from "../../../form/CheckboxField"
import { Logger } from "../../../service/Logger"
import { TunnelDataContext } from "../../context/TunnelDataContext"
import Axios from "axios"
import React, { useContext, useEffect, useState } from "react"
import { Spinner } from "react-bootstrap"

const PaylineCBForm = ({ certifySignature }) => {
  const { tunnelData } = useContext(TunnelDataContext)
  const [token, setToken] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    const initPayline = () => {
      setIsLoading(true)
      setToken(null)

      const headers = {
        Authorization: `Bearer ${tunnelData.access_token}`,
        Accept: "*/*",
        "Content-Type": "application/json"
      }

      const sessionLang = getSessionVoyageurLang()
      const languageFromOrder = tunnelData.data.order.orderLanguageTag.split("-")[0]
      const language = sessionLang ? sessionLang.split("-")[0].toLowerCase() : languageFromOrder

      const payload = {
        transactionId: tunnelData.data.order.id,
        opl: tunnelData.opl,
        returnUrl:
          window.location.origin +
          `/payline?transactionId=${tunnelData.data.order.id}&opl=${tunnelData.data.order.opl}&tenant=${tunnelData.tenant}`,
        cancelUrl:
          window.location.origin +
          `/payline?transactionId=${tunnelData.data.order.id}&opl=${tunnelData.data.order.opl}&tenant=${tunnelData.tenant}`,
        supplierName: tunnelData.data.order.supplierName,
        firstName: tunnelData.data.order.customer.firstName,
        lastName: tunnelData.data.order.customer.name,
        email: tunnelData.data.order.customer.email,
        language
      }

      if (tunnelData.isJourneyResumedAtHome) {
        payload.returnUrl = payload.returnUrl.concat("&isJourneyResumedAtHome=true")
        payload.cancelUrl = payload.cancelUrl.concat("&isJourneyResumedAtHome=true")
      }

      Axios.post(`${tunnelData.apiUrl}middle-bank-service/api/v1/payments/authorization/init`, payload, {
        headers
      })
        .then((res) => {
          if (!cancelled) {
            setToken(res.data.paylineToken)
          }
        })
        .catch((e) => {
          Logger.error("error when call on  /api/v1/payments/authorization/init api ", true, e.stack)
        })
    }

    initPayline()
    const onVoyageurLanguageChange = () => initPayline()
    window.addEventListener("voyageurLanguageChange", onVoyageurLanguageChange)
    return () => {
      cancelled = true
      window.removeEventListener("voyageurLanguageChange", onVoyageurLanguageChange)
    }
  }, [tunnelData])

  useEffect(() => {
    if (!token) {
      return
    }
    const script = document.createElement("script")

    script.src = tunnelData.paylineWidgetScriptSrc
    script.async = true

    document.body.appendChild(script)
    setIsLoading(false)

    return () => {
      document.body.removeChild(script)
    }
  }, [token, tunnelData.paylineWidgetScriptSrc])

  const spinnerStyle = {
    display: "block",
    width: "2em",
    height: "2em",
    margin: "0 auto"
  }

  return (
    <>
      {isLoading && <Spinner animation="border" as="span" className="spinner" style={spinnerStyle} />}
      {token && <div id="PaylineWidget" data-token={token} data-template="column" data-auto-init="true" />}
      <CheckboxField
        label={loc`I, undersigned ${certifySignature} certify that I am the holder of the bank card used for the request for payment of my 1st payment.`}
        name="userIsRealCardOwner"
        className="flex-nowrap optin p-0"
      />
    </>
  )
}

export default PaylineCBForm
